module.exports = __webpack_public_path__ + "assets/media/add-point.ab47521f.svg";